import axios from 'axios';
import shortid from 'shortid';
import APP from '../modules/index';
// import { createBrowserHistory } from 'history';

// const history = createBrowserHistory();
const requestId = shortid.generate();

axios.interceptors.request.use(
  function (config) {
    const token = window.localStorage.getItem('Token');
    const sessionId = window.sessionStorage.getItem('sessionId');

    if (token != null) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    if (sessionId != null) {
      config.headers['x-session-id'] = sessionId;
    }

    return config;
  },
  function (err) {
    return Promise.reject(err);
  }
);

// let isSessionExpired = false;
axios.interceptors.response.use(
  function (config) {
    if (config.headers['content-type'] === 'application/download') {
      const url = URL.createObjectURL(
        new Blob([config.data], { type: 'application/vnd.ms-excel' })
      );
      const link = document.createElement('a');
      link.href = url;
      let fileName = 'download';
      if (config.config && config.config.url) {
        let arr = config.config.url.split('/');
        fileName = arr[arr.length - 1] + '_report.xlsx';
      }
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
    }

    return config;
  },
  function (error) {
    if (401 === error.response.status) {
      // if(!isSessionExpired){
      //   isSessionExpired = true;
      //   window.localStorage.removeItem('Token');
      //   history.goBack();
      //   alert("Session Expired Please login again");
      // }
    }
    return Promise.reject(error);
  }
);

export const fetch = {
  get({ url, requestParams = {}, callbackHandler }) {
    const ins = axios.get(`${APP.Constants.THIRD_PARTY_API_HOST}${url}`, {
      params: requestParams,
      requestId
    });
    outputHandler({ ins, callbackHandler });
  },
  getExcel({ url, requestParams = {}, callbackHandler }) {
    const ins = axios.get(`${APP.Constants.THIRD_PARTY_API_HOST}${url}`, {
      params: requestParams,
      requestId,
      responseType: 'arraybuffer',
      headers: { 'Content-Type': 'application/json' }
    });
    outputHandler({ ins, callbackHandler });
  },
  getZip({ url, requestParams = {}, callbackHandler }) {
    const ins = axios.get(`${APP.Constants.THIRD_PARTY_API_HOST}${url}`, {
      params: requestParams,
      requestId,
      responseType: 'arraybuffer',
      headers: { 'Content-Type': 'application/zip' }
    });
    outputHandler({ ins, callbackHandler });
  },

  post({ url, requestBody = {}, callbackHandler }) {
    const ins = axios.post(`${APP.Constants.THIRD_PARTY_API_HOST}${url}`, {
      ...requestBody,
      requestId
    });
    outputHandler({ ins, callbackHandler });
  },
  postSignal({ url, requestBody = {}, callbackHandler, signal  }) {
    const ins = axios.post(`${APP.Constants.THIRD_PARTY_API_HOST}${url}`, {
      ...requestBody,
      requestId
    },{signal});
    outputHandler({ ins, callbackHandler });
  },
  delete({ url, requestBody = {}, callbackHandler }) {
    const ins = axios.delete(`${APP.Constants.THIRD_PARTY_API_HOST}${url}`, {
      ...requestBody,
      requestId
    });
    outputHandler({ ins, callbackHandler });
  },
  put({ url, requestBody = {}, callbackHandler }) {
    const ins = axios.put(`${APP.Constants.THIRD_PARTY_API_HOST}${url}`, {
      ...requestBody,
      requestId
    });
    outputHandler({ ins, callbackHandler });
  }
};

const outputHandler = ({ ins, callbackHandler }) => {
  ins
    .then((response) => {
      callbackHandler({
        status: APP.Constants.SUCCESS,
        message: '',
        payload: response.data
      });
    })
    .catch((error) => {
      console.log('error', error);
      let errMessage = '';
      if (
        error.response &&
        error.response.data.message &&
        error.response.data.message.includes('duplicate')
      ) {
        errMessage = 'Duplicate Test Suite Name';
      } else {
        errMessage = 'Something went worng...';
      }
      callbackHandler({
        status: APP.Constants.FAILURE,
        message: errMessage,
        payload: {}
      });
    });
};
